import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

declare let gtag: Function;

@Injectable({providedIn: 'root'})
export class MetricsService {
  constructor() {
  }

  login() {
    gtag('event', 'login', {environment: environment.name});
  }

  openDoor() {
    gtag('event', 'open_door', {environment: environment.name});
  }

  checkInAdultRegistered() {
    gtag('event', 'check_in_adult_registered', {environment: environment.name});
  }

  checkInMinorRegistered() {
    gtag('event', 'check_in_minor_registered', {environment: environment.name});
  }

  checkInAdultEnded() {
    gtag('event', 'check_in_adult_ended', {environment: environment.name});
  }

  checkInMinorEnded() {
    gtag('event', 'check_in_minor_ended', {environment: environment.name});
  }

  checkInSigned() {
    gtag('event', 'check_in_signed', {environment: environment.name});
  }

  checkInMinorRelation() {
    gtag('event', 'check_in_minor_relation', {environment: environment.name});
  }

  mrzCapture() {
    gtag('event', 'mrz_capture', {environment: environment.name});
  }

  mrzStarted() {
    gtag('event', 'mrz_started', {environment: environment.name});
  }

  mrzSkipped() {
    gtag('event', 'mrz_skipped', {environment: environment.name});
  }

  mrzSuccess() {
    gtag('event', 'mrz_success', {environment: environment.name});
  }

  mrzPartialSuccess() {
    gtag('event', 'mrz_partial_success', {environment: environment.name});
  }

  deposit() {
    gtag('event', 'deposit', {environment: environment.name});
  }

  depositInProcess() {
    gtag('event', 'deposit_in_process', {environment: environment.name});
  }
}
